import { SvgIcon } from "@mui/material";
import { ReactComponent as Icon } from "@/assets/icons/actions/SaveWhiteIcon.svg";

interface SaveWhiteIconComponentProps {
	className?: string;
	style?: React.CSSProperties;
	onClick?: () => void;
}

export const SaveWhiteIconComponent: React.FC<SaveWhiteIconComponentProps> = ({ className, style, onClick }) => {
	return (
		<SvgIcon onClick={onClick} component={Icon} className={`!w-[20px] !h-[20px] ${className}`} style={style} viewBox={"-3 -3 24 24"} />
	);
};
